/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\KIA.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:13:55 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function KIA(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M617.59,627.81c0,1.84,.58,2.9,1.64,2.9,.87-.1,1.64-.48,2.32-.97l301.18-195.48c5.09-3.56,11.19-5.39,17.39-5.22h66.19c10.14,0,17.01,6.76,17.01,16.91v126.39c0,15.27-3.38,24.16-16.91,32.27l-80.3,48.31c-.8,.56-1.73,.89-2.7,.97-.97,0-1.93-.77-1.93-3.58v-147.45c0-1.74-.48-2.9-1.64-2.9-.85,.1-1.65,.43-2.32,.97l-220.12,143.01c-5.02,3.38-10.92,5.22-16.91,5.12h-145.91c-10.24,0-17.01-6.76-17.01-17.01v-182.14c0-1.35-.58-2.61-1.74-2.61-.85,.11-1.65,.44-2.32,.97l-145.23,87.16c-1.45,.97-1.83,1.64-1.83,2.32,0,.58,.29,1.16,1.26,2.22l103.78,103.68c1.35,1.35,2.32,2.42,2.32,3.57,0,.97-1.55,1.74-3.38,1.74h-93.73c-7.34,0-13.04-1.06-17.01-5.02l-62.91-62.81c-.48-.58-1.18-.93-1.93-.97-.68,.03-1.35,.23-1.93,.58l-105.13,63.2c-6.38,3.86-10.73,4.93-17.01,4.93H74.07c-10.34,.1-17.11-6.76-17.11-16.91v-123.97c0-15.37,3.38-24.16,17.01-32.27l80.78-48.51c.63-.41,1.37-.65,2.13-.68,1.26,0,1.93,1.26,1.93,4.06v166.01c0,1.74,.39,2.51,1.64,2.51,.87-.1,1.64-.48,2.42-.97l272.87-164.17c5.22-3.57,11.59-5.31,17.97-5.02h146.87c10.14,0,17.01,6.76,17.01,16.91l-.1,181.95h.1Z"/>
        </svg>
    );
}

export default KIA;
